export const formatNumber = (number = 0, separator = " ") => {
    const parts = number.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, separator);
    return parts.join(".");
};

export const roundNumber = (number = 0, precision = 0, direction = "up") => {
    const roundFactor = Math.pow(10, precision);
    const multiplied = Number(number) * roundFactor;
    const auxRounded =
        direction === "up" ? Math.ceil(multiplied) : Math.floor(multiplied);
    return auxRounded / roundFactor;
};

export const addCommas = numero => {
    if (numero > 999999) {
        const conPunto = numero.substring(0, numero.length - 9);
        const conPunto2 = numero.substring(numero.length - 9, numero.length - 6);
        const conPunto3 = numero.substring(numero.length - 6, numero.length);
        numero = conPunto + "," + conPunto2 + "," + conPunto3;
    } else {
        if (numero > 999) {
            const conPunto = numero.substring(0, numero.length - 6);
            const conPunto2 = numero.substring(numero.length - 6, numero.length);
            numero = conPunto + "," + conPunto2;
        }
    }
    return numero;
};

export const round = number => Math.round((number + Number.EPSILON) * 100) / 100;

export const isZero = value => parseInt(value, 10) === 0;
